<template>
  <div class="tw-flex tw-h-full tw-flex-col tw-items-center tw-justify-center tw-text-center">
    <div v-if="icon" class="tw-my-4 tw-mt-8">
      <slot name="icon">
        <Component :is="icon" class="tw-h-12 tw-w-12" :class="emptyStateIcon" />
      </slot>
    </div>
    <div class="tw-space-y-3">
      <p v-if="title" class="tw-font-outfit tw-text-2xl tw-font-semibold tw-text-gray-800">
        {{ title }}
      </p>
      <p class="tw-text-base tw-text-gray-700">{{ description }}</p>
    </div>
  </div>
</template>

<script setup lang="ts">
interface Props {
  title?: string
  description: string
  icon?: Component
}

defineProps<Props>()

const { getThemeToken } = useTheme()
const emptyStateIcon = getThemeToken('secondary-text')
</script>
